
import { defineComponent, ref } from 'vue'
import { complexTiresWork, standartTiresWork } from '@/assets/data/prices'

export default defineComponent({
  setup() {
    const visible = ref(false)
    const isSUVType = ref(false)
    const toggleVisible = () => visible.value = !visible.value

    const setCarTypeToSUV = () => isSUVType.value = true
    const setCarTypeToCar = () => isSUVType.value = false

    return {
      toggleVisible,
      visible,
      isSUVType,
      setCarTypeToSUV,
      setCarTypeToCar,
      complexTiresWork,
      standartTiresWork
    }
  }
})
